import { combineReducers } from 'redux-immutable'
import standardCostPriceCreateReducer from './standard-cost-price-create-reducer'
import standardCostPriceEditReducer from './standard-cost-price-edit-reducer'
import standardCostPriceGetReducer from './standard-cost-price-get-reducer'
import standardCostPriceExportReducer from './standard-cost-price-export-reducer'

export default combineReducers({
  standardCostPriceCreate: standardCostPriceCreateReducer,
  standardCostPriceEdit: standardCostPriceEditReducer,
  standardCostPriceGet: standardCostPriceGetReducer,
  standardCostPriceExport: standardCostPriceExportReducer,
})



// WEBPACK FOOTER //
// ./src/reducers/standard-cost-price/index.js